// extracted by mini-css-extract-plugin
export default {"visuallyHidden":"I29vsG","container":"nd4xNQ"};